import React from "react";
import {
  createComponentBase,
} from "../../../libs/components";
import { Tooltip } from "../tooltip";
import DatePicker, { DateObject } from "react-multi-date-picker";
import { Icon } from "../icon";

export interface inputProps {
  className?: string;
  value: Date | undefined;
  onChange: (date: DateObject | null, options: { validatedValue: string | string[]; input: HTMLElement; isTyping: boolean; }) => void;
  label?: string;
  error?: string;
  isError?: boolean;
  min?: Date;
  max?: Date;
  placeholder?: string;
}

export const CustomDatePicker = ({
  value,
  onChange,
  label,
  error,
  min,
  max,
  isError,
  placeholder = "Select Date",
  className,
}: inputProps) => {
  const componentClassName = "a-customDatePicker";
  const modifiers = {
    [isError ? "error" : ""]: true,
  };
  const { Container } = createComponentBase(componentClassName, "div");

  const CustomInput = ({
    onFocus,
    value,
  }: {
    onFocus?: () => void;
    value?: string;
  }) => {
    return (
      <div>
        <Tooltip message={error} isVisible={isError}>
          <div className={`${componentClassName}__input`} onFocus={onFocus}>
            <input
              className={`${componentClassName}__input__field`}
              value={value}
              readOnly
              placeholder={placeholder}
            />
            <div className={`${componentClassName}__input__icon`}>
              <Icon icon="calendar" />
            </div>
          </div>
        </Tooltip>
      </div>
    );
  };

  return (
    <Container className={className} modifiers={modifiers}>
      {label && <p className={`${componentClassName}__label`}>{label}</p>}

      <DatePicker
        containerClassName={`${componentClassName}__input__container`}
        render={<CustomInput />}
        value={value ? new Date(value) : undefined}
        onChange={onChange}
        minDate={min}
        maxDate={max}
        calendarPosition="bottom-right"
        numberOfMonths={1}
      />
    </Container>
  );
};
